import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Font extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }
  // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Font'
  // Define default properties here
    static instanceDefaults() {
    return {
        name: '',
        type: '',
        sample: ''
    }
  }
}
const servicePath = 'fonts'
const servicePlugin = makeServicePlugin({
    Model: Font,
    service: feathersClient.service(servicePath),
    servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
